import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();

// Register the service worker for offline capabilities
// new version

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js");

      console.log("✅ Service worker registered:", registration.scope);

      // Immediately check for a newer service worker
      await registration.update();

      // Check if an update is already waiting
      if (registration.waiting) {
        window.dispatchEvent(
          new CustomEvent("swUpdateAvailable", {
            detail: registration,
          }),
        );
      }

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;

        if (!newWorker) return;

        console.log("🔄 New service worker found");

        newWorker.addEventListener("statechange", () => {
          console.log("SW state:", newWorker.state);

          if (
            newWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            console.log("🆕 New version available");

            window.dispatchEvent(
              new CustomEvent("swUpdateAvailable", {
                detail: registration,
              }),
            );
          }
        });
      });

      // Check for updates when user returns to the tab
      const handleVisibilityChange = async () => {
        if (document.visibilityState === "visible") {
          try {
            await registration.update();
          } catch (error) {
            console.error("Service worker update check failed:", error);
          }
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Optional periodic update check
      const updateInterval = setInterval(
        () => {
          registration.update();
        },
        15 * 60 * 1000,
      );

      // Reload after the new worker takes control
      let refreshing = false;

      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;

        refreshing = true;

        console.log("🔄 New service worker activated. Reloading...");

        window.location.reload();
      });

      // Cleanup
      window.addEventListener("beforeunload", () => {
        clearInterval(updateInterval);

        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange,
        );
      });
    } catch (error) {
      console.error("❌ Service worker registration failed:", error);
    }
  });
}
